import { render, staticRenderFns } from "./TrainerDashboard.vue?vue&type=template&id=22ed690d&scoped=true"
import script from "./TrainerDashboard.vue?vue&type=script&lang=js"
export * from "./TrainerDashboard.vue?vue&type=script&lang=js"
import style0 from "./TrainerDashboard.vue?vue&type=style&index=0&id=22ed690d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed690d",
  null
  
)

export default component.exports